import React, { useState, useEffect } from "react";
import injectSheet from "react-jss";
import { GetData } from "../../utils/axios";
import GustavModal from "../GustavModal/GustavModal";
import { ExtraInfoData } from "../../assets/help/ExtraInfoData";

const ExtraInfo = ({ classes, extraInfoData: { endPoint, title, name } }) => {
  const [showModal, setShowModal] = useState(false);
  const [items, setItems] = useState([]);
  const [infoTitle, setInfoTitle] = useState(title || "");

  useEffect(() => {
    const getData = async () => {
      const data = await GetData(endPoint);
      setItems(data);
    };
    if (endPoint) {
      getData();
    } else {
      var data = ExtraInfoData.find((x) => x.name === name);
      setItems(data.items);
      setInfoTitle(data.title);
    }
  }, []);

  return (
    <>
      {showModal && (
        <GustavModal width="35rem" onCloseRequest={() => setShowModal(false)}>
          <div className={classes.title}>{infoTitle}</div>
          <div className={classes.itemHolder}>
            {items?.map((item, index) => (
              <div className={classes.itemContainer} key={index}>
                <div className={classes.itemName}>{item.namn}</div>
                <div className={classes.itemDescription}>
                  {item.beskrivning}
                </div>
              </div>
            ))}
          </div>
        </GustavModal>
      )}
      <span className={classes.linkTitle} onClick={() => setShowModal(true)}>
        Info
      </span>
    </>
  );
};

const styles = {
  linkTitle: {
    color: "#335cda",
    marginBottom: "4px",
    marginLeft: "4px",
    fontSize: "13px",
    textDecoration: "underline",
    display: "flex",
    //alignItems: "center",
    cursor: "pointer",
    //lineHeight: "1.5",
    fontWeight: "500",
  },
  title: {
    position: "absolute",
    fontSize: "20px",
    textDecoration: "underline",
    fontWeight: "500",
    marginBottom: "10px",
  },
  itemHolder: {
    marginTop: "35px",
    overflowY: "auto",
    maxHeight: "550px",
  },
  itemContainer: { marginBottom: "15px" },
  itemName: {
    fontSize: "16px",
    marginBottom: "4px",
    fontWeight: "500",
  },
  itemDescription: {},
  mainContainer: {
    marginLeft: 10,
    color: "blue",
    cursor: "pointer",
    fontWeight: "700",
  },
  "@media (max-width: 1023px)": {},
};
export default injectSheet(styles)(ExtraInfo);
